type GetBase64Image = {
  url?: any;
  callback: (param: any) => void;
  onError: OnErrorEventHandler;
  outputFormat?: string;
};

export type CropType = {
  width: number;
  height: number;
  x: number;
  y: number;
};

export const dataURLtoBlob = (dataURL: any) => {
  var arr = dataURL.split(',');
  var mime = arr[0]?.match(/:(.*?);/)[1];
  var bstr = window.atob(arr[1]);
  var n = bstr.length;
  var u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime }); // eslint-disable-line
};

export const getBase64Image = ({
  url,
  callback,
  onError,
  outputFormat,
}: GetBase64Image) => {
  var img = new Image(); // eslint-disable-line
  img.crossOrigin = 'anonymous';
  img.onerror = onError;
  img.onload = function () {
    var canvas: HTMLCanvasElement | null = document.createElement(
      'CANVAS'
    ) as HTMLCanvasElement;
    var ctx = canvas?.getContext('2d');
    var dataURL;
    canvas.height = img.height;
    canvas.width = img.width;
    ctx?.drawImage(img, 0, 0);
    dataURL = canvas.toDataURL(outputFormat);
    callback(dataURL);
    canvas = null;
  };
  img.src = url;
};

const createImage = (url: string) =>
  new Promise((resolve, reject) => {
    const image = new Image(); // eslint-disable-line
    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', (error) => reject(error));
    image.setAttribute('crossOrigin', 'anonymous'); // needed to avoid cross-origin issues on CodeSandbox
    image.src = url;
  });

export const getCroppedImg = async (
  imageSrc: string,
  crop: CropType | null
) => {
  const image = (await createImage(imageSrc)) as HTMLImageElement;
  const canvas = document.createElement('canvas');
  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;
  const maxSafeSize = 4096;

  if (crop) {
    const maxSize = Math.max(crop.width, crop.height);
    const ratioSafeSize = maxSize > maxSafeSize ? maxSafeSize / maxSize : 1;
    canvas.width = crop.width * ratioSafeSize;
    canvas.height = crop.height * ratioSafeSize;
    const ctx = canvas?.getContext('2d');

    ctx?.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width * ratioSafeSize,
      crop.height * ratioSafeSize
    );
  }

  // As Base64 string
  // const base64Image = canvas.toDataURL("image/jpeg");
  // return base64Image;

  // As a blob
  return new Promise((resolve) => {
    const dataUrl = canvas.toDataURL('image/jpeg');
    const blob = dataURLtoBlob(dataUrl);

    resolve({ blob, croppedImageUrl: dataUrl });
  });
};

export default getCroppedImg;
